import { createApi, DefaultResponsePlugin, LoggerPlugin, AuthHeaderPlugin, RefreshTokenPlugin, AccessDeniedResponsePlugin } from '@common/index';
import modules from '../api-modules';

const api = createApi({ modules });
api.registerPlugins([AccessDeniedResponsePlugin, DefaultResponsePlugin, LoggerPlugin, AuthHeaderPlugin, RefreshTokenPlugin]);

export const useApi = () => api.getModules();
